export default __webpack_public_path__ + "static/media/about_icon3.95783e1b.svg";